import React from "react";
import PropTypes from "prop-types";

const overlayStyle = (isMobile) => ({
  position: "fixed",
  inset: 0,
  backgroundColor: "rgba(14, 23, 44, 0.65)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1200,
  padding: isMobile ? "12px" : "20px",
});

const modalStyle = (isMobile) => ({
  width: isMobile ? "90%" : "100%",
  maxWidth: "520px",
  background: "#ffffff",
  borderRadius: "16px",
  boxShadow: "0 25px 60px rgba(0,0,0,0.25)",
  overflow: "hidden",
  maxHeight: isMobile ? "88vh" : "auto",
  overflowY: isMobile ? "auto" : "visible",
  position: "relative",
});

const headerStyle = {
  padding: "20px 48px 10px 24px",
  borderBottom: "1px solid #f0f0f0",
};

const bodyStyle = {
  padding: "16px 24px 24px",
  color: "#1f2933",
  lineHeight: 1.5,
  fontSize: "15px",
};

const listStyle = {
  paddingLeft: "20px",
  margin: "10px 0 20px",
};

const ACCENT_COLOR = "#4fb573";

const badgeStyle = {
  display: "inline-flex",
  alignItems: "center",
  gap: "6px",
  background: "#ecfdf3",
  color: ACCENT_COLOR,
  padding: "6px 10px",
  borderRadius: "999px",
  fontSize: "12px",
  fontWeight: 600,
};

const footerStyle = {
  padding: "16px 24px 24px",
  borderTop: "1px solid #f0f0f0",
  display: "flex",
  justifyContent: "flex-end",
};

const primaryButtonStyle = {
  border: "none",
  borderRadius: "999px",
  background: ACCENT_COLOR,
  color: "#fff",
  padding: "10px 22px",
  fontWeight: 600,
  cursor: "pointer",
};

const closeButtonStyle = {
  position: "absolute",
  top: "12px",
  right: "12px",
  background: "transparent",
  border: "none",
  fontSize: "22px",
  cursor: "pointer",
  color: "#64748b",
};

const BonusHelpModal = ({ isOpen = false, onClose = () => {} }) => {
  const [isMobile, setIsMobile] = React.useState(false);

  React.useEffect(() => {
    if (typeof window === "undefined") return;
    const mediaQuery = window.matchMedia("(max-width: 991px)");
    const update = () => setIsMobile(mediaQuery.matches);
    update();
    mediaQuery.addEventListener("change", update);
    return () => mediaQuery.removeEventListener("change", update);
  }, []);

  if (!isOpen) return null;

  return (
    <div style={overlayStyle(isMobile)} onClick={onClose}>
      <div
        style={{
          position: "relative",
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div
          style={modalStyle(isMobile)}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <button aria-label="Fermer" style={closeButtonStyle} onClick={onClose}>
            ×
          </button>
          <div style={headerStyle}>
            <div style={badgeStyle}>Aide Bonus Réparation</div>
            <h2 style={{ margin: "12px 0 0", fontSize: "20px" }}>
              Comprendre et utiliser le Bonus Réparation
            </h2>
          </div>
          <div style={bodyStyle}>
            <p>
              Le Bonus Réparation est une aide financière proposée par l’État (source&nbsp;: Ministère de la Transition Écologique) pour inciter à réparer plutôt qu’à remplacer un appareil. Il est accessible depuis le 15 décembre 2022 sur plus de 60 types d’appareils électroménagers et électroniques.
            </p>
            <p>Pour en bénéficier :</p>
            <ul style={listStyle}>
              <li>
                <strong>1. Vérifier l’éligibilité :</strong> appareil adulte (hors garantie) appartenant à la liste officielle (lave-linge, lave‑vaisselle, four, aspirateur, TV, smartphone, etc.). Le montant varie selon la catégorie (ex.&nbsp;: 10&nbsp;€ pour une bouilloire, jusqu’à 60&nbsp;€ pour un lave-linge, 100&nbsp;€ pour un smartphone avec écran et batterie remplacés).
              </li>
              <li>
                <strong>2. Passer par un réparateur labellisé QualiRépar :</strong> seul un professionnel référencé peut appliquer le bonus, directement déduit de la facture.
              </li>
              <li>
                <strong>3. Préparer vos justificatifs :</strong> preuve d’achat, numéro de série ou facture peuvent être demandés par le réparateur ou pour les contrôles éventuels.
              </li>
              <li>
                <strong>4. Payer la part restante :</strong> le bonus est pris en charge par l’éco-organisme (EcoLogic ou Ecosystem) et n’est pas cumulable si l’appareil est encore sous garantie.
              </li>
            </ul>
            <p>
              Confirmez le montant exact avec votre réparateur QualiRépar et consultez le site officiel pour la liste complète des équipements et des montants&nbsp;: <a href="https://www.ecologie.gouv.fr/politiques-publiques/bonus-reparation-quest-ce-que-cest" target="_blank" rel="noreferrer noopener">ecologie.gouv.fr</a>.
            </p>
          </div>
          <div style={footerStyle}>
            <button type="button" style={primaryButtonStyle} onClick={onClose}>
              J’ai compris
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

BonusHelpModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

export default BonusHelpModal;
